module.exports = __webpack_public_path__ + "media/images/emblems/Duernten-blazon-4ec97668c7d8e94965f39914cedba86f.svg";